module.exports = __webpack_public_path__ + "icon-72x72.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/icon-72x72.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/icon-72x72.png
// module chunks = 12